<template>
    <div class="video-player" @keydown="hotkey(e)">
        <div v-if="$route.name==='videoPlayer'">
            <timeline></timeline>
            <h1 v-if="instanceId">
                
            </h1>
        </div>
        <div class="panel video-player-wrapper" v-if="video">
            <div class="panel-body nopad">
                <div id="video-wrapper" class="col-sm-12 video-wrapper" :class="{'col-md-9': !expanded}">
                    <div class="video-player-background">
                        <div class="panel-heading">
                            <h2 class="clearfix">
                                 <router-link 
                                    v-if="instanceId" 
                                    class="course-link"
                                    :to="{
                                        name: 'course', 
                                        params: { 
                                            termId: $route.query.term, 
                                            courseId: video.course.courseId,
                                            instanceId: instanceId
                                        } 
                                    }">
                                    
                                    {{video.course.name}} 
                                </router-link>
                                > 
                                {{video.title}} - {{totalDuration | minutesAndSeconds}}
                                <i class="clippie fa fa-info-circle" v-tooltip="'Videoplayer Shortcuts: space &#61 pause, up/down &#61 speed, left&#47;right &#61 10sec skips, F &#61 full screen, D &#61 Distraction Free View'"></i> </h2>
                        </div>
                        <div class="ttto-progress-wrapper">
                            <div class="ttto-progress" v-bind:style="{ width: totalProgress + '%' }"></div>
                        </div>
                        <i class="fa fa-expand" @click="toggleExpand()"></i>
                        <div class="hotkey-layer" @click="onHotkeyLayerClick($event)">
                            <poly-video ref="videoPlayer" :class="{ 'hide-annotations': showAnnotations === false }" :sources="[ videoPlayerUrl ]" :vjsOptions="videoPlayerVjsOptions" :persistPlaybackSpeed="true" :persistPlaybackQuality="true" @click="test()" @ready="playerReady()" @play=" loadAnnotations()" @loadedsource="onVideoLoad()" @ended="playNextChapter($event)" v-show="video.video_chapters">
                            </poly-video>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 col-md-3 chapters-wrapper" :class="{'col-md-push-9': expanded}">
                    <div class="panel-heading">
                        <h2>Lesson Progress</h2>
                    </div>
                    <VuePerfectScrollbar class="scroll-area">
                        <ul class="chapters" v-if="selectedChapter">
                            <li v-bind:class="{'selected':selectedChapter.id === chapter.id}" v-for="chapter in video.video_chapters" @click="selectChapter(chapter)" class="chapter row">
                                <div v-if="chapter.heading" class="chapter-heading">{{chapter.heading}}</div>
                                <div class="col-xs-9">{{chapter.title}}</div>
                                <div class="col-xs-3 text-right">{{chapter.duration | minutesAndSeconds}}</div>
                                <div class="col-xs-12 chapter-progress-wrapper">
                                    <div class="ttto-progress-wrapper">
                                        <i v-if="selectedChapter.id === chapter.id" class="current-chapter fa fa-circle"></i>
                                        <div class="ttto-progress" v-bind:style="{ width: chapterProgress(chapter.progress, chapter.duration) + '%' }"></div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </VuePerfectScrollbar>
                </div>
                <div class="comments-wrapper" :class="{'col-md-9': expanded, 'col-md-pull-3': expanded}">
                    <div class="tabs clearfix" :class="{'expanded': expanded}">
                        <ul>
                            <li v-bind:class="{'active': showTab==='description'}" @click="setTab('description')">Description</li>
                            <li v-if="video.exercise && $route.name==='videoPlayer'" v-bind:class="{'active': showTab==='exercise'}" @click="setTab('exercise')">
                                Exercise
                                <img v-if="video.exercise.exercise_hand_ins.length > 0" src="../assets/img/exercise-icon-grey.png">
                                <img v-else src="../assets/img/exercise-icon.png">
                            </li>
                            <li v-if="video.exercise && $route.name==='campus-dashboard'" v-bind:class="{'active': showTab==='exercise'}" @click="setTab('exercise')">
                                Exercise
                            </li>
                            <li v-if="assignmentData && video.assignment && $route.name==='videoPlayer'" v-bind:class="{'active': showTab==='assignment'}" @click="setTab('assignment')">
                                Assignment
                                <img v-if="(assignmentData.submissions)
                                    || (assignmentData && new Date(assignmentData.dueDate) < new Date())" src="../assets/img/assignment-icon-grey.png">
                                <img v-else src="../assets/img/assignment-icon.png">
                            </li>
                            <li v-if="assignmentData && video.assignment && $route.name==='campus-dashboard'" v-bind:class="{'active': showTab==='assignment'}" @click="setTab('assignment')">
                                Assignment
                            </li>
                            <li v-bind:class="{'active': showTab==='comments'}" @click="setTab('comments')">
                                Comments
                                <span class="badge" v-if="comments">{{comments.length}}</span>
                            </li>
                            <li v-bind:class="{'active': showTab==='resources'}" @click="setTab('resources')">Resources</li>
                            <li v-bind:class="{'active': showTab==='transcript'}" @click="setTab('transcript')">Live Transcript</li>
                        </ul>
                    </div>
                    <div v-if="video" v-show="showTab==='description'" class="description">
                        <div class="col-sm-9">
                            <h3 class="video-title">{{video.title}}</h3>
                            <div v-html="video.description" class="video-description-cms-text"></div>
                        </div>
                        <div class="col-sm-3 exercise-sidebar">
                            <h4 v-if="video.lesson_files && video.lesson_files.length > 0">Lesson Files</h4>
                            <ul>
                                <li v-for="file in video.lesson_files">
                                    <a :href="file.url" target="_blank">{{file.url | filenameFromUrl}}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div v-if="video" v-show="showTab==='files'" class="description">
                        <h4>Lesson Files</h4>
                        <ul>
                            <li v-for="file in video.lesson_files">
                                <a :href="file" target="_blank">{{file.url | filenameFromUrl}}</a>
                            </li>
                        </ul>
                    </div>
                    <div class="transcript-container video-tabs-content" v-show="showTab==='transcript' && selectedChapter && selectedChapter.transcript">
                        <div class="transcript" v-if="transcriptLoaded === false">Live Transcripts will appear here when playing a video chapter.</div>
                        <div class="transcript" id="transcript" ref="transcript" @click="jumpToTime($event.target.parentNode.dataset.begin)">
                        </div>
                    </div>
                    <div v-show="showTab==='resources'">
                        <div class="resources">
                            <!--<div class="panel-heading"><h2>Resources</h2></div>-->
                            <div v-if="instanceId && video.week">
                                <resources :instanceId="instanceId" :currentWeek="video.week"></resources>
                            </div>
                        </div>
                    </div>
                    <div class="video-tabs-content" v-show="showTab==='assignment'">
                        <assignment-submission v-if="assignmentData" :data="assignmentData"></assignment-submission>
                    </div>
                    <div class="video-tabs-content exercise" v-show="showTab==='exercise'">
                        <div v-if="video.exercise" class="exercise-wrapper">
                            <div class="row">
                                <div class="col-md-9">
                                    <img class="background" :src="exerciseImage">
                                    <div style="height:100%;" class="col-sm-9 exercise-description">
                                        <h4><span v-if="$route.name !== 'campus-dashboard'">Week {{$route.query.week}}, </span>{{video.exercise.title}}</h4>
                                        <div v-html="video.exercise.description"></div>
                                    </div>
                                    <div class="col-sm-12 col-md-3">
                                        <img v-if="video.exercise.image" :src="exerciseImage" @click="showLightBox=true" class="exercise-image">
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-3 exercise-sidebar">
                                    <div class="exercise-files">
                                        <div v-if="$route.name !== 'campus-dashboard'">
                                            <h4>Due Date<i class="clippie fa fa-info-circle" v-tooltip="'Find your exercise due date below.'"></i></h4>
                                            <div v-if="video.exercise.dueDate">
                                                {{video.exercise.dueDate | localDate}}<br>
                                                <countdown :date="video.exercise.dueDate"></countdown>
                                            </div>
                                            <div v-else>
                                                {{friday | localDate}}<br>
                                                <countdown :date="friday"></countdown>
                                            </div>
                                        </div>
                                        <h4>Exercise Files:<i class="clippie fa fa-info-circle" v-tooltip="'Find files here required for the exercise'"></i></h4>
                                        <ul v-if="(video.exercise.files && video.exercise.files.length > 0)
                                                  || 
                                                  (video.exercise.watermarkedFiles && video.exercise.watermarkedFiles.length > 0)
                                                    ">
                                            <li v-for="file in video.exercise.files">
                                                <!-- <a :href="file" target="_blank">{{file | filenameFromUrl}}</a> -->
                                                <a @click.prevent="downloadFile(file, 'exercise', video.exercise.id)" href="#">{{file | filenameFromUrl}}</a>
                                            </li>
                                            <li v-for="file in video.exercise.watermarkedFiles">
                                                <a @click.prevent="downloadFile(file, 'exercise', video.exercise.id)" href="#">{{file | filenameFromUrl}}</a>
                                            </li>
                                        </ul>
                                        <p v-else>No files for this exercise</p>
                                    </div>
                                    <div v-if="$route.name !== 'campus-dashboard'">
                                        <form @submit.prevent="submitHandIn()">
                                            <h4 v-if="video.exercise.fileRequired === true">Submit Exercise<i class="clippie fa fa-info-circle" v-tooltip="'Drag your file(s) here to submit.'"></i></h4>
                                            <dropzone v-if="video.exercise.fileRequired === true" id="exerciseUpload" ref="exerciseUpload" url="#" v-bind:use-custom-dropzone-options="true" v-bind:thumbnail-height="0" v-bind:dropzone-options="dropzoneOptions">
                                            </dropzone>
                                            <ul class="self-assessment">
                                                <h4>Self Assessment<i class="clippie fa fa-info-circle" v-tooltip="'Let us know how you feel about this week\'s content for this course'"></i></h4>
                                                <li><label><input value="3" type="radio" v-model="handIn.assessment" name="confidence">I nailed this</label></li>
                                                <li><label><input value="2" type="radio" v-model="handIn.assessment" name="confidence">I mostly get this</label></li>
                                                <li><label><input value="1" type="radio" v-model="handIn.assessment" name="confidence">I need help</label></li>
                                            </ul>
                                            <div class="form-group" v-if="handIn.assessment == 1">
                                                Are you stuck? Please reach out to your supervisor in chat or create a <router-link to="/support">Support Ticket</router-link>.
                                            </div>
                                            <button type="submit" class="btn btn-success">Submit</button>
                                        </form>
                                        <div class="previous-submissions" v-if="video.exercise.exercise_hand_ins.length > 0">
                                            <h4>Submitted Files</h4>
                                            <div v-for="hand_in in video.exercise.exercise_hand_ins">
                                                <div v-for="file in hand_in.url" class="hand-in-link">
                                                    <a :href="file" target="_blank">{{file | filenameFromUrl}}
                                                    </a>
                                                </div>
                                                <div class="separator">
                                                    {{hand_in.createdAt | shortDate}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="video-tabs-content" v-show="showTab==='comments'">
                        <ul class="comments" v-if="comments">
                            <li v-for="comment in comments">
                                <div class="row top-level">
                                    <div class="col-xs-1">
                                        <img v-if="comment.user.avatar" v-bind:src="comment.user.avatar">
                                    </div>
                                    <div class="col-xs-9">
                                        <p class="author">
                                            {{comment.user.firstName}} {{comment.user.lastName}} at <span class="jump-link" @click="jumpToTime(comment.time)">{{comment.time | minutesAndSeconds}}</span>
                                        </p>
                                        <div v-html="comment.text"></div>
                                    </div>
                                    <div class="col-xs-2">
                                        <div>{{comment.createdAt | timeSince}} ago</div>
                                        <div>
                                            <button class="btn btn-xs reply-button" @click.prevent="showReplyForm=comment.id">Reply</button>
                                            <button 
                                            class="btn btn-xs delete-button" 
                                            @click.prevent="deleteComment(comment)"
                                            v-if="localStorage.roles.includes('CourseAdmin') || localStorage.roles.includes('Admin')">
                                                Delete
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <ul class="replies" v-if="comment.children.length > 0">
                                    <li v-for="child in comment.children">
                                        <div class="row">
                                            <div class="col-xs-1">
                                                <img v-if="child.user.avatar" v-bind:src="child.user.avatar">
                                            </div>
                                            <div class="col-xs-9">
                                                <p class="author">
                                                    {{child.user.firstName}} {{child.user.lastName}} at <span @click="jumpToTime(comment.time)">{{comment.time | minutesAndSeconds}}</span>
                                                </p>
                                                <div v-html="child.text"></div>
                                            </div>
                                            <div class="col-xs-2">
                                                <div>{{child.createdAt | timeSince}} ago</div>
                                                <button 
                                                class="btn btn-xs delete-button"
                                                @click.prevent="deleteComment(child)"
                                                v-if="localStorage.roles.includes('CourseAdmin') || localStorage.roles.includes('Admin')">
                                                    Delete
                                                </button>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                                <form v-if="showReplyForm===comment.id" @submit.prevent="addComment(comment.id, comment.user)">
                                    <div class="form-group">
                                        <vue-html5-editor @change="updateCommentReply($event, comment.id)" :content="content" :height="200"></vue-html5-editor>
                                        <!-- <textarea v-model="commentReply[comment.id]" class="form-control"></textarea> -->
                                    </div>
                                    <button type="submit" class="btn btn-xs reply-button">Submit Comment Reply</button>
                                </form>
                            </li>
                        </ul>
                        <form @submit.prevent="addComment()">
                            <div class="form-group">
                                <label>Add Timeline Comment:<i class="clippie fa fa-info-circle" v-tooltip="'Add and reply to comments directly on the timeline. Great for asking and answering questions specific to a point in time. Set your time marker to a place and add a comment!'"></i></label>
                                <vue-html5-editor @change="updateComment" :content="content" :height="200"></vue-html5-editor>
                                <!-- <textarea v-model="newComment" class="form-control"></textarea> -->
                            </div>
                            <button type="submit" class="btn btn-success">Add Comment</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div class="lightbox" @click="showLightBox=false" v-if="showLightBox">
            <i @click="showLightBox=false" class="fa fa-remove"></i>
            <img @click.stop :src="exerciseImage">
        </div>
    </div>
</template>
<script>
import aws from '../services/aws';
import videos from '../services/videos';
import assignments from '../services/assignments';
import submissions from '../services/submissions';
import exercises from '../services/exercises';
import router from '../router';

import videoComment from './reusable/discussion/VideoComment.vue';
import timeline from './widgets/Timeline.vue';
import PolyVideo from './reusable/poly-video';
import videoJsResolutionSwitcher from '../packages/videojs-resolution-switcher';
import overlay from 'videojs-overlay';
import _ from 'underscore';
import Dropzone from 'vue2-dropzone';
import speedTest from '../packages/speed-test';
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moment from 'moment';
import countdown from './reusable/countdown/CountdownTimer.vue';

import animation from '../packages/animation';
import S3Utils from '../packages/s3-utils';
import stringUtils from '../utils/strings';

import Resources from './widgets/Resources.vue';
import assignmentSubmission from './reusable/assignments-table/templates/Child.vue';
import * as Sentry from "@sentry/browser";

// videojs plugins
require('../packages/videojs-markers');
require('../packages/videojs-transcript');
require('../packages/videojs-framebyframe');
require('../packages/videojs-enlarge');

import vtt from "videojs-vtt.js";
const WebVTT = vtt.WebVTT;
const VTTCue = vtt.VTTCue;


import toastr from 'toastr';

import { VueTabs, VTab } from 'vue-nav-tabs'
import 'vue-nav-tabs/dist/vue-tabs.min.css'

export default {
    data() {
        return {
            videoWeek: null,
            courseId: null,
            instanceId: null,
            showLightBox: false,
            video: {},
            videoId: null,
            transcriptLoaded: false,
            selectedChapter: null,
            currentProgress: 0,
            totalProgress: 0,
            newComment: null,
            commentReply: {},
            comments: null,
            selectedComment: null,
            showReplyForm: null,
            showTab: 'description',
            showAnnotations: true,
            showCaptions: 'hidden',
            hotKeysEnabled: true,
            assignmentData: null,
            dropzoneOptions: {
                autoProcessQueue: false,
                addRemoveLinks: true,
                maxFilesize: 4000
            },
            files: [],
            handIn: {
                assessment: null
            },
            assessments: ['feel completely lost', 'think you got it', 'nailed this!'],
            playbackRate: 1.0,
            videoPlayerUrl: null,
            videoPlayerVjsOptions: {
                fluid: true,
                playbackRates: [0.7, 1.0, 1.25, 1.5, 2.0, 3.0],
                plugins: {
                    framebyframe: {
                        fps: 23.98,
                        steps: [
                            { icon: 'fa-undo', step: -10 },
                            // { icon: 'fa-step-backward', step: -1 },
                            // { icon: 'fa-step-forward', step: 1 },
                            { icon: 'fa-repeat', step: 10 },
                        ]
                    },
                },
            },
            currentTime: 0, // Set in saveProgress(), but otherwise unused?
            expanded: false,
            autoplay: true,
        }
    },
    components: {
        countdown,
        PolyVideo,
        VueTabs,
        VTab,
        timeline,
        Resources,
        Dropzone,
        VuePerfectScrollbar,
        'assignment-submission': assignmentSubmission
    },
    mounted() {
        var self = this;
        window.addEventListener('keyup', function(e) {
            if (e.keyCode === 27 && self.expanded === true) self.toggleExpand();
        });


        document.addEventListener("keydown", self.hotkey);

        $('#app').click(this.onAppClick);

        this.courseId = this.$route.params.courseId;
        console.log("COURSE ID")
        console.log(this.courseId)
        this.instanceId = this.$route.params.instanceId;
        this.videoId = this.$route.params.videoId;
        this.getVideoForWeek();
        this.getAssignment();
        this.blockRightClick();


        this.$bus.$on('reload_assignment', function() {
            self.getAssignment();
        });
        this.$bus.$on('weekChanged', (week) => {

            setTimeout(() => {
                self.videoWeek = week + 1;
                router.replace({ path: '/videos', name: 'videoPlayer', params: { instanceId: self.instanceId, videoId: self.videoId }, query: { week: week + 1 } })
                this.$nextTick(() => {
                    this.getVideoForWeek();
                })
            }, 300)

        });


        if (this.$route.query.tab) {
            this.showTab = this.$route.query.tab;

            this.setTab(this.$route.query.tab);

            // window.setTimeout(function() {
            //     window.scrollTo(0,document.body.scrollHeight - 500);
            // },1000);
        }
    },

    beforeDestroy() {
        $('#app').off('click', this.onAppClick);
    },

    methods: {

        downloadFile(file, type, id) {
            this.$bus.$emit('download', file, type, id);

        },
        onAppClick(ev) {
            // If the event didn't originate from within the hotkey layer,
            // then we can disable hotkeys.
            const $target = $(ev.target);
            const fromHotkeyLayer = !!$target.closest('.hotkey-layer')[0];
            if (!fromHotkeyLayer) {
                this.hotKeysEnabled = false;
            }
        },
        onHotkeyLayerClick(ev) {
            this.hotKeysEnabled = true;
        },
        blockRightClick() {
            (function() {
                var blockContextMenu, videoElement;

                blockContextMenu = function(evt) {
                    evt.preventDefault();
                };

                videoElement = document.querySelector('video');
                videoElement.addEventListener('contextmenu', blockContextMenu);
            })();
        },
        updateCommentReply(content, id) {
            this.commentReply[id] = content;

        },
        async deleteComment(comment) {   
            const yes = window.confirm('Are you sure you want to delete this comment?');
            if (!yes) {
                return;            
            }
            await videos.deleteComment(comment.id);
            if (comment.children && comment.children.length) {
                for (const comment of comment.children) {
                    await videos.deleteComment(comment.id);
                }
            }
            toastr.success('Comment deleted');
            this.getComments();
        },
        updateComment(content) {
            this.newComment = content;
        },
        setTab(tab) {
            this.showTab = tab;
            this.$store.dispatch('toggle', { type: 'loading', boolean: false });

            this.$router.replace({ name: this.$route.name, params: { courseId: this.courseId, instanceId: this.instanceId, videoId: this.videoId }, query: { week: this.$route.query.week, tab: tab, chapter: this.$route.query.chapter } })
        },
        hotkey(e) {
            var self = this;
            if (self.hotKeysEnabled === false || !e) return;
            if (!self.$refs.videoPlayer) return;
            var player = self.$refs.videoPlayer.getVjsPlayer();

            switch (e.keyCode) {
                case 70:
                    // F for fullscreen
                    $('.vjs-fullscreen-control').click();
                    break;
                case 32:
                    // space for pause
                    e.preventDefault();
                    if (player.paused()) player.play();
                    else player.pause();
                    return false;
                    break;
                case 68:
                    // D for 'distraction-free'mode
                    if (this.expanded === false) this.toggleExpand();
                    break;
                case 27:
                    // D for 'distraction-free'mode
                    if (this.expanded === true) this.toggleExpand();
                    break;
                case 37:
                    if (player.currentTime() > 10) {
                        player.currentTime(player.currentTime() - 10);
                    }
                    break;
                case 39:
                    if (player.currentTime() < player.duration()) {
                        player.currentTime(player.currentTime() + 10);
                    }
                    break;

                case 38:
                    // up arrow to increase speed
                    e.preventDefault();
                    var rates = self.videoPlayerVjsOptions.playbackRates;
                    var currentRate = rates.findIndex(function(r) { return r === player.playbackRate() });
                    if (!rates[currentRate + 1]) return;
                    self.playbackRate = rates[currentRate + 1];
                    player.playbackRate(self.playbackRate);
                    return false;
                    break;
                case 40:
                    // down arrow to decrease speed
                    e.preventDefault();
                    var rates = self.videoPlayerVjsOptions.playbackRates;
                    var currentRate = rates.findIndex(function(r) { return r === player.playbackRate() });
                    if (!rates[currentRate - 1]) return;
                    self.playbackRate = rates[currentRate - 1];
                    player.playbackRate(self.playbackRate);
                    return false;
                    break;
            }
        },
        toggleExpand() {
            this.expanded = !this.expanded;
            var route = this.$route;
            this.$router.replace({ name: route.name, params: { instanceId: this.instanceId, videoId: this.videoId }, query: { week: this.$route.query.week, expanded: this.expanded } })
        },
        popOut() {
            var url = window.location.href + '&popout=true';
            window.open(url, "_blank", "toolbar=no,scrollbars=yes,resizable=yes,top=500,left=500,width=1200,height=800");

        },
        getAssignment() {
            var self = this;
            assignments.get(this, this.courseId, this.instanceId, this.$route.query.week).then(function(response) {
                if (response.data.length > 0) {
                    submissions.getMine(this, response.data[0].id).then(function(res) {
                        response.data[0].submissions = res.data.submissions;
                        self.assignmentData = response.data[0];
                    });
                }

            });
        },
        playerReady(player) {
            var self = this;

            if (!player) player = this.$refs.videoPlayer.getVjsPlayer();


            // if user's progress is within 10 seconds of the end of the video,
            // don't start playing from that point -- go back to the beginning instead

            // if (self.selectedChapter) {
            //     var closeToEndOfVideo = Math.ceil((self.selectedChapter.progress+1)/10)*10 == Math.ceil((self.selectedChapter.duration+1)/10)*10;

            //     if (self.selectedChapter.progress && closeToEndOfVideo === false) {
            //        player.currentTime(self.selectedChapter.progress);
            //     }
            //     console.log('PROGRESS');
            //     console.log(self.selectedChapter.progress);
            // }
            player.markers({
                markers: [],
                onMarkerReached: function(event) {
                    self.selectedComment = event;
                }
            });

            if (localStorage.getItem('preferred_video_volume')) {
                const vol = parseFloat(localStorage.getItem('preferred_video_volume'));
                player.volume(vol);
            }

            var Button = videojs.getComponent('Button');
            var AnnotationsButton = videojs.extend(Button, {
                constructor: function() {
                    Button.apply(this, arguments);
                    this.addClass('fa');
                    this.addClass('fa-keyboard-o');
                    this.controlText('Annotations');
                },

                handleClick: function() {
                    this.toggleClass('disabled');
                    self.showAnnotations = !self.showAnnotations;
                }
            });
            videojs.registerComponent('AnnotationsButton', AnnotationsButton);
            player.getChild('controlBar').addChild('AnnotationsButton', {}, 5);

            player.remoteTextTracks().on('change', function(e, c) {
                var selected = $('.vjs-texttrack-settings').siblings('.vjs-selected').html();
                if (selected.indexOf('English') > -1) {
                    self.showCaptions = 'showing';
                } else {
                    self.showCaptions = 'hidden';
                }

            })

            player.on('ratechange', function(e) {
                self.playbackRate = player.playbackRate();
            });

            player.on('volumechange', function(e) {
                localStorage.setItem('preferred_video_volume', player.volume());
            });

            var throttle = function(fn, threshhold, scope) {
                threshhold || (threshhold = 250);
                var last,
                    deferTimer;
                return function() {
                    var context = scope || this;

                    var now = +new Date,
                        args = arguments;
                    if (last && now < last + threshhold) {
                        // hold on to it
                        clearTimeout(deferTimer);
                        deferTimer = setTimeout(function() {
                            last = now;
                            fn.apply(context, args);
                        }, threshhold);
                    } else {
                        last = now;
                        fn.apply(context, args);
                    }
                };
            };

            const updateProgress = throttle(this.saveProgress, 15000, this);

            player.on('timeupdate', () => {
                const chapter = this.selectedChapter;
                const progress = player.currentTime();
                updateProgress(chapter, progress);
            });

            player.on('ended', () => {
                const chapter = this.selectedChapter;
                const progress = player.duration();
                this.mockUpdate(progress);

                const progressUpdate = {
                    userId: localStorage.user_id,
                    videoId: this.video.id,
                    chapterId: chapter.id,
                    progress: progress,
                };
                this.$root.$socket.emit('video_progress', progressUpdate);

            });

        },
        loadAnnotations() {
            var self = this;
            var player = self.$refs.videoPlayer.getVjsPlayer();
            var annotations = [];

            self.selectedChapter.annotations.forEach(function(annotation) {
                var content = '<p class="annotation">' + annotation.text + '</p>';

                content += '<div class="buttons">';

                if (annotation.controlKeys) {
                    annotation.controlKeys.forEach(function(key) {
                        content += '<span class="control controlkey ' + key + '">' + key + '</span>';
                    });
                }


                if (annotation.hotKeys) {
                    content += '<span class="control controlkey ' + annotation.hotKeys + '">' + annotation.hotKeys + '</span>';
                }

                if (annotation.mouseButtons) {
                    annotation.mouseButtons.forEach(function(button) {
                        content += '<span class="control mousebutton ' + button + '"></span>';
                    })
                }

                content += '</div>';

                annotations.push({
                    content: content,
                    start: annotation.time,
                    end: annotation.time + 5,
                    align: 'bottom-' + annotation.position
                })

            });

            player.overlay({
                overlays: annotations
            });
        },

        jumpToTime(timestamp) {
            this.$refs.videoPlayer.getVjsPlayer().currentTime(timestamp);
        },
        selectChapter(chapter) {
            this.selectedChapter = chapter;
            this.videoPlayerUrl = S3Utils.buildS3Url(
                'ttto-course-videos-raw',
                `${chapter.url}.mp4`,
            );
        },
        onVideoLoad() {
            this.getTranscript();
            this.loadCaptions();
            this.getComments();

            // Resume the video from where the user left off. If the user
            // left off within 21 seconds of the end of the video, go back to
            // the beginning.
            const player = this.$refs.videoPlayer.getVjsPlayer();
            const chapter = this.selectedChapter;

            function closeToEndOfVideo() {
                return chapter.progress >= chapter.duration - 21;
            }

            if (chapter.progress && !closeToEndOfVideo()) {
                player.currentTime(chapter.progress);
            } else {
                // Since the autoplay feature below depends on the
                // currentTime() reporting 0 until the video has loaded, we
                // have to set the starting time to something non-zero.
                player.currentTime(0.001);
            }

            // Auto-play the video after the time changes.
            // The implementation? Well, it's... interesting. Things tried:
            //  - calling play():
            //      results in double-start bug where some of the old buffer
            //      is played before the new time code kicks in
            //  - waiting for 'loadeddata' event and calling play():
            //      event never fires (thanks videojs)
            //  - waiting for 'timeupdate' event and calling play():
            //      results in same double-start bug, although with a smaller
            //      old buffer blip
            //  - waiting for 'timeupdate' event, waiting and then polling
            //    the currentTime() with timeouts, calling play() upon the
            //    observed update:
            //      she works! The observed behavior is that if calling
            //      currentTime() directly after setting it, or after
            //      'timeupdate', the reported time is the new time code that
            //      we set. However, if we wait some amount of time with
            //      setTimeout() after 'timeupdate', it will report the time
            //      to be 0 until the time change actually takes place.
            function runAutoplay() {
                const targetTime = player.currentTime();
                let pollCount = 0;
                const pollDelay = 50;
                const maxPollCount = 5000 / pollDelay; // Bail after 5 seconds


                function pollAutoplay() {
                    if (pollCount++ > maxPollCount) {
                        return; // Stop trying
                    }
                    if (player) {
                        try {
                            const reportedTime = player.currentTime();
                            if (reportedTime === targetTime) {
                                player.play();
                                return;
                            }
                        } catch (e) {
                            console.log(e)
                        }
                    }
                    setTimeout(pollAutoplay, pollDelay);
                }

                player.one('timeupdate', () => {
                    setTimeout(pollAutoplay, 1);
                });
            }
            if (this.autoplay) {
                runAutoplay();
            }
        },
        getAssessment(assessment) {
            return this.assessments[assessment - 1];
        },
        addHandin() {
            var self = this;

            if (!this.handIn.assessment) {
                toastr.error('Please let us know how you think you did');
                return false;
            }

            if (this.$refs.exerciseUpload &&
                this.$refs.exerciseUpload.dropzone.files.length < 1 &&
                this.handIn.fileRequired === true) {
                toastr.error('Please add the file');
                return false;
            }

            var handIn = {
                exerciseId: this.video.exercise.id,
                assessment: this.handIn.assessment,
            }

            if (this.files.length > 0) {
                handIn.url = this.files;
            }
            self.$store.dispatch('toggle', { type: 'loading', boolean: true });

            exercises.submitHandIn(this, handIn).then(function(response) {

                self.$store.dispatch('toggle', { type: 'loading', boolean: false });

                if (response.data.success === true) {
                    toastr.success('Hand-in submitted');
                    self.handIn = {};
                    self.files = [];
                    self.getVideoForWeek();
                    self.$bus.$emit('student_submission');
                    if (self.$refs.exerciseUpload) {
                        self.$refs.exerciseUpload.dropzone.removeAllFiles();
                    }
                } else {
                    toastr.error('Error submitting hand-in');
                }
            });
        },
        submitHandIn() {
            var self = this;

            if (this.$refs.exerciseUpload && this.$refs.exerciseUpload.dropzone.files.length > 0) {
                this.uploadHandIn().then(function(done) {
                    self.addHandin();
                }).catch(function(e) {
                    toastr.error('Error uploading file')
                    self.uploading = false;
                })
            } else {
                self.addHandin();
            }
        },

        uploadHandIn() {

            var self = this;

            if (self.uploading === true) {
                toastr.error('You are already uploading a file');
                return false;
            }

            self.uploading = true;

            var files = this.$refs.exerciseUpload.dropzone.files;

            var promises = [];

            files.forEach(function(file) {

                const ext = file.name.split('.').pop()
                let filename = file.name.replace(/&|\$|@|=|;|:|\%|\+|,|\?/g, '').split('.');
                filename.pop();
                filename = filename.join('.');
                filename = filename + '_' + stringUtils.shortId('tt') + '.' + ext;

                let promise = new Promise(function(resolve, reject) {
                    aws.signature(file, filename, 'ttto-hand-ins').then(function(signature) {
                        aws.getPresignedUrl(self, 'ttto-hand-ins', filename, 'putObject').then(function(presignedUrl) {                            
                            const acceleratedUrl = presignedUrl.data.replace('s3.us-west-2','s3-accelerate');
                            aws.upload(file, filename, signature, 'ttto-hand-ins', acceleratedUrl).then(function(response) {
                                self.files.push(response.url);
                                resolve(true)
                            }).catch(function(error) {
                                console.log(error)
                                reject();

                            });
                        });
                    });
                });

                promises.push(promise);
            });


            return new Promise(function(resolve, reject) {
                Promise.all(promises).then(function(res) {
                    self.uploading = false;
                    resolve(true)
                }).catch(function(e) {
                    self.uploading = false;
                    reject();
                })


            });

        },
        addComment(parentId, commenter) {
            var self = this;

            var timestamp = self.$refs.videoPlayer.getVjsPlayer().currentTime();
            var comment = {
                timestamp: timestamp,
                userId: localStorage.account_id,
                chapterId: self.selectedChapter.id,
                videoId: self.videoId,
                courseTitle: self.video.course.name,
                videoTitle: self.video.title,
                chapterTitle: self.selectedChapter.title,
                courseId: self.courseId,
                instanceId: self.instanceId,
                week: self.$route.query.week
            }

            if (parentId) {
                comment.parentId = parentId;
                comment.text = self.commentReply[parentId];
                comment.commenter = commenter.id;
            } else {
                comment.text = self.newComment
            }

            videos.addComment(self, comment).then(function(response) {
                if (response.data.id) {
                    toastr.success('Comment added');
                    self.newComment = null;
                    self.commentReply = {};
                    self.getComments();
                    document.querySelector('.content').innerHTML = ''
                } else {
                    toastr.error('Error adding comment');
                }

            });

        },
        mockUpdate(timestamp) {
            var self = this;
            var chapters = self.video.video_chapters;

            chapters.forEach(function(chapter, index) {
                if (chapter.id === self.selectedChapter.id && (!chapter.progress || chapter.progress < timestamp)) {
                    self.video.video_chapters[index].progress = timestamp;
                    self.$forceUpdate();
                }
            });
        },
        /**
         * This method is typically called from a `timeupdate` event on the
         * player. We've had a bug where progress updates from a video are
         * accidentally applied to the wrong chapter, so forcing the caller
         * to supply the chapter and the progress is a safer option than just
         * using the current chapter and current player time.
         *
         * Bug: https://www.wrike.com/open.htm?id=358173341
         *
         * @param {object} chapter
         * @param {number} chapter.id
         * @param {number} chapter.duration
         * @param {number} progress
         */
        saveProgress(chapter, progress) {

            const testUserIds = ['2277', '2115'];

            if (chapter.id !== this.selectedChapter.id) {
                if (!testUserIds.includes(localStorage.user_id)) {
                    return;
                }
            }

            this.currentTime = progress;

            this.mockUpdate(progress);

            const progressUpdate = {
                userId: localStorage.user_id,
                videoId: this.video.id,
                chapterId: chapter.id,
                progress: progress,
            };
            
            try {
                this.$root.$socket.emit('video_progress', progressUpdate);
            } catch (e) {
                Sentry.captureException(e);
            }
            this.currentProgress++;

            this.highlightTranscript(chapter, progress);

        },
        highlightTranscript(chapter, progress) {
            const transcript = document.querySelector('.transcript-body');

            if (transcript) {
                var lines = transcript.children;
                var begin, end, line;
                for (var i = 0; i < lines.length; i++) {
                    line = lines[i];
                    begin = line.getAttribute('data-begin');
                    if (i < lines.length - 1) {
                        end = lines[i + 1].getAttribute('data-begin');
                    } else {
                        end = chapter.duration || Infinity;
                    }
                    if (progress > begin && progress < end) {
                        if (!line.classList.contains('is-active')) { // don't update if it hasn't changed
                            line.classList.add('is-active');
                            animation.scrollToElement(line);
                        }
                    } else {
                        line.classList.remove('is-active');
                    }
                }
            }
        },
        stopAutoplay() {
            //this.videoPlayerVjsOptions.autoplay = false;
            this.autoplay = false;
        },
        queueVideo(chapter) {
            this.selectChapter(chapter);
        },
        playNextChapter(e) {
            var self = this;
            var chapters = self.video.video_chapters;
            var index = chapters.findIndex(function(x) { return x.id === self.selectedChapter.id });
            self.selectedComment = null;

            var transcriptContainer = document.getElementById('transcript');

            transcriptContainer.innerHTML = '';
            self.transcriptLoaded = false;

            if ((index + 1) === chapters.length) {
                return;
            } else {
                var nextChapter = chapters[index + 1];
                self.selectChapter(nextChapter);
            }
        },
        loadVideo: function(response) {
            var self = this;
            self.video = response.data;

            if (self.video.exercise && self.video.exercise.exercise_hand_ins.length > 0) {
                var handIns = self.video.exercise.exercise_hand_ins.sort(function(a, b) {
                    return a.id < b.id;
                });
                self.handIn.assessment = handIns[0].assessment;
            }

            var firstChapter = response.data.video_chapters[0];
            var continuing = false;

            if (self.video.lastWatched) {
                let lastWatched = response.data.video_chapters.findIndex(function(c) { return c.id === self.video.lastWatched.id });
                if (lastWatched > -1) {
                    continuing = true;
                    firstChapter = response.data.video_chapters[lastWatched];
                }
            }

            if (firstChapter) {
                self.selectChapter(firstChapter);
                self.calculateTotalProgress();
                self.$store.dispatch('toggle', {
                    type: 'loading',
                    boolean: false,
                });
            }



            if (this.$route.query.chapter) {
                const chapterId = parseInt(this.$route.query.chapter)
                const chapter = self.video.video_chapters.find(c => c.id === chapterId)
                this.selectChapter(chapter);
                this.$router.replace({ name: this.$route.name, params: { courseId: this.courseId, instanceId: this.instanceId, videoId: this.videoId }, query: { week: this.$route.query.week, tab: this.$route.query.tab } })
            }

        },
        getVideoForWeek() {
            var self = this;
            self.$store.dispatch('toggle', { type: 'loading', boolean: true });

            videos.getByWeek(this, this.instanceId, this.$route.query.week).then(function(response) {
                self.$store.dispatch('toggle', { type: 'loading', boolean: false });
                self.loadVideo(response);
                self.getAssignment();
                self.$forceUpdate();
            });

        },
        getVideo() {
            var self = this;
            self.$store.dispatch('toggle', { type: 'loading', boolean: true });

            videos.getOne(this, this.videoId).then(function(response) {
                self.$store.dispatch('toggle', { type: 'loading', boolean: false });
                self.loadVideo(response);
                self.getAssignment();

            });

        },
        loadCaptions() {
            var self = this;
            var chapter = this.selectedChapter;
            var player = this.$refs.videoPlayer.getVjsPlayer();
            var oldTracks = player.remoteTextTracks();
            var i = oldTracks.length;
            while (i--) {
                player.removeRemoteTextTrack(oldTracks[i]);
            }


            var track = player.addRemoteTextTrack({ kind: 'captions', srclang: 'en', label: 'English' });

            var addCaptions = function(track) {
                if (track && !track.activeCues) {
                    if (track.mode !== 'showing') {
                        track.mode = 'hidden';
                    }

                    window.setTimeout(function() {
                        addCaptions(track);
                    }, 500);

                } else {
                    if (!chapter.transcript.text) return;

                    chapter.transcript.text.forEach(function(cue) {
                        player.remoteTextTracks()[0].addCue(new VTTCue(cue.start, cue.end, cue.text));
                        var tracks = player.remoteTextTracks();

                        for (var i = 0; i < tracks.length; i++) {
                            var track = tracks[i];
                            if (track.kind === 'captions' && track.language === 'en') {
                                track.mode = self.showCaptions;
                            }
                        }


                    });
                }
            };
            addCaptions(player.remoteTextTracks()[0]);

            var captionsOff = $('.vjs-texttrack-settings').next().html().replace('captions off', 'off');
            $('.vjs-texttrack-settings').next().html(captionsOff);


        },
        getTranscript() {
            var self = this;
            var player = this.$refs.videoPlayer.getVjsPlayer();
            var chapter = this.selectedChapter;
            self.transcriptLoaded = false;
            if (chapter && chapter.transcript && chapter.transcript.text) {

                var transcriptContainer = document.getElementById('transcript');

                transcriptContainer.innerHTML = ''

                var options = {
                    followPlayerTrack: true,
                    showTitle: false,
                    clickArea: 'text',
                    showTrackSelector: false,
                    // autoscroll: true,
                }

                window.setTimeout(function() {
                    var transcript = player.transcript(options);
                    transcript.id = 'transcript';
                    transcriptContainer.appendChild(transcript.el());
                    self.transcriptLoaded = true;
                }, 1500)



            }
        },
        getComments() {
            var self = this;
            self.comments = null;
            videos.getComments(self, self.selectedChapter.id).then(function(response) {
                var video = self.$refs.videoPlayer.getVjsPlayer();
                if (_.isFunction(video.markers.removeAll)) video.markers.removeAll();

                var topLevel = [];
                var comments = response.data;

                comments.forEach(function(c, i) {
                    if (c.parentId === null) {
                        comments.splice(i, 1);
                        comments.unshift(c)
                    }
                })

                comments = comments.sort(function(a, b) {
                    return a.parentId - b.parentId;
                });

                if (comments && comments.length > 0) {
                    comments.forEach(function(comment) {
                        if (!comment.parentId) {
                            comment.children = []
                            topLevel.push(comment);
                        } else {
                            var index = topLevel.findIndex(function(x) { return x.id === comment.parentId });
                            topLevel[index].children.push(comment);
                        }
                    });

                }
                window.setTimeout(function() {
                    self.comments = topLevel;
                    self.$refs.videoPlayer.getVjsPlayer().markers.add(topLevel);
                }, 1000)
            });

        },
        chapterProgress(progress, duration) {
            if (!progress) return 0;
            return ((progress / duration) * 100).toFixed(2);
        },
        calculateTotalProgress() {
            if (this.video && this.video.video_chapters[0]) {

                var totalDuration = this.video.video_chapters.reduce((a, b) => ({ duration: a.duration + b.duration }));

                var totalProgress = this.video.video_chapters.filter(function(x) { return x.progress })
                if (totalProgress.length > 0) {
                    totalProgress = totalProgress.reduce((a, b) => ({ progress: a.progress + b.progress }));
                    this.totalProgress = ((totalProgress.progress / totalDuration.duration) * 100).toFixed(2);
                } else {
                    this.totalProgress = 0;
                }
            }
        },
    },
    watch: {
        '$route.params.videoId': function() {
            if (this.videoId === this.$route.params.videoId) {
                return;
            }

            this.courseId = this.$route.params.courseId;
            this.instanceId = this.$route.params.instanceId;
            this.videoId = this.$route.params.videoId;
            this.assignmentData = null;
            if (!this.showTab) {
                this.showTab = 'description';
            }
            this.getVideoForWeek();
        },
        '$route.query.week': function() {
            this.getVideoForWeek();
        },
        '$route.query.tab': function() {
            if (this.$route.query.tab) this.showTab = this.$route.query.tab;
        },
        currentProgress: function() {
            this.calculateTotalProgress();
        },

    },
    computed: {
        friday() {

            return moment(this.$store.state.currentTerm.startDate)
                .add(this.$store.state.currentWeek, 'weeks')
                .tz('America/Vancouver')
                .endOf('week').subtract(1, 'days').local().toDate();

        },
        exerciseImage() {
            var self = this;
            if (this.video.exercise && this.video.exercise.image) {
                return self.video.exercise.image;
            }
            if (this.$store.getters.courses.length > 0) {
                const courseImage = this.$store.getters.courses.filter(function(c) {
                    return c.id == self.instanceId
                })
                if(courseImage.length) {
                    return courseImage[0].image;                
                }
            }

        },
        currentWeek() {
            this.videoWeek = this.$store.getters.currentWeek;
            return this.$store.getters.currentWeek;
        },
        
        totalDuration() {
            if (this.video && this.video.video_chapters && this.video.video_chapters[0]) {
                var totalDuration = this.video.video_chapters.reduce((a, b) => ({ duration: a.duration + b.duration }));
                return totalDuration.duration;
            }

        }
    },
}

</script>
<style lang="scss" scoped>
    a.course-link {
        text-decoration: none;
        color:#fafafa;
        &:hover {
            text-decoration: underline;

        }
    }
.hand-in-link {
    margin-bottom: .5rem;
}

.separator {
    font-size: 12px;
    text-align: right;
    font-weight: 100;
    border-bottom: 1px solid #666;
    color: #ccc;
    margin-bottom: 2rem;
}


.chapter-heading {
    font-size: 16px;
    border-bottom: 1px solid #555;
    padding-bottom: .5rem;
    margin-bottom: .5rem;
    margin-left: -1rem;
    padding-left: 1rem;
    color: #fff;
}

h2 {
    i {
        float: right;
        top: 12px;
    }
}

.panel-body.nopad {
    margin-bottom: 3rem !important;
}

.jump-link {
    color: #33ccff;
    cursor: pointer;
    font-weight: 700;
}

.exercise-description {
    margin-top: 20px;
}


.form-group {
    margin-top: 20px;
}

.form-control:not([type="file"]) {
    margin-top: 10px;
    background: rgba(0, 0, 0, .2) !important;
}


.exercise-files {
    clear: both;
    margin-top: 20px;

    li {
        word-break: break-word;
    }
}

.self-assessment {
    input {
        margin-right: 10px;
    }
}

.exercise-wrapper {
    position: relative;

    .col-md-9 {
        padding-bottom: 6rem;
    }

    span {
        background: transparent !important;
    }
}

.description {
    float: left;
    white-space: pre-wrap;
    padding: 20px;
    width: 100%;
}


.exercise-image {
    cursor: pointer;
    z-index: 9999;
    position: relative;
    margin-top: 45px;
    box-shadow: 0px 0px 15px 3px rgba(0, 0, 0, .3);
}


.exercise-sidebar {
    border-left: 1px solid #666;

    li a {
        display: inline-block;
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 100%;
    }
}

.background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    object-fit: cover;
    opacity: .25;
    max-height: 100%;
    z-index: 0;
}

.btn {
    margin-top: 15px
}

.video-tabs-content {
    padding: 0 20px 20px 20px;
}

.fa-expand {
    float: right;
    position: relative;
    bottom: -3rem;
    z-index: 999999;
    color: #fff;
    background: rgba(0, 0, 0, .5);
    padding: 1rem;
    cursor: pointer;
}

h1 {
    margin-top: -5px;
    margin-bottom: -50px;
    //pointer-events: none;
    position: relative;
    top: -44px;
    padding-left: 16px;
    font-size: 30px;

    a {
        color: inherit;

        &:hover {
            text-decoration: none;
        }
    }

}

.video-player {
    //margin-top:2rem;
}

.video-player-wrapper {
    background: #0f0f0f;
    margin-top: 30px;
}

.video-wrapper {
    &:focus {
        border: 1px solid red;
    }

    padding-bottom:2rem;
    transition:width 1s;
    //padding-left:0px;
    //padding-right:0px;
}

.chapters-wrapper {
    padding-right: 0px;
    transition: width .5s;
}

.chapter-progress-wrapper {
    padding-left: 5px;
}

.resources {
    //margin-top:3rem;
    padding: 20px;
}

.chapter {
    .col-xs-9 {}

    &.selected {
        color: #33ccff;
    }
}

textarea {
    background: #212121;
}

.reply {
    margin-top: 2rem;
}

.top-level {
    padding: 2rem;
    position: relative;

    i {
        color: #33ccff;
        cursor: pointer;

    }

    .jump {
        top: 1rem;
        right: 1rem;
        position: absolute;
    }

    .toggle {
        position: absolute;
        top: 3rem;
        right: 1.25rem;
        display: inline-block;

        i {
            font-size: 2rem;
        }
    }
}

.comments {
    margin: 1rem auto 2rem;

    .author {
        margin: 0;
    }

    .author,
    .author span {
        font-size: 1.2rem;
    }

    li {
        //border-bottom:solid 1px #666;
    }
}

.replies {
    padding-left: 4rem;
}

// .progress-wrapper{
//     margin-top:20px
// }

.current-chapter {
    position: absolute;
    left: -3px;
    bottom: 6px;
}


@media screen and (max-width: 992px) {
    .current-chapter {
        top: 65%;
    }
}



.video-player-background {
    background: #222;
}

.scroll-area {
    height: 504px;

}

.chapters {
    padding-top: 20px;
    padding-bottom: 20px;
    background-color: #222 !important;
    border-left: 1px solid #555;
    padding-left: 10px;
    padding-right: 10px;
    overflow-y: auto;

    .chapter-progress-wrapper {
        padding-right: 5px;
    }

    li {
        position: relative;
    }

    .row {
        margin-bottom: 15px;
        padding-right: 0;
    }
}

.transcript {
    line-height: 2rem;
    position: relative;

    span {
        padding: .25rem;
        cursor: pointer;
        color: #fff;
    }

}

.transcript-container {
    padding: 20px;
}

</style>
<style lang="scss">
.video-player-wrapper .description .col-sm-9 span {
    background-color: transparent !important;
}

.tabs {
    clear: both;
    border-bottom: 1px solid #555;
    width: 100%;
    margin-top: 2rem;
    padding-bottom: 0;
    font-style: italic;

    &.expanded {
        margin-top: 0;
    }

    .badge {
        background: #33ccff;
    }

    li {
        float: left;
        padding: 1rem;
        height: 30px;
        line-height: 30px;
        cursor: pointer;
        margin-bottom: 0;
        height: 100%;
        border-right: 1px solid #555;

        &.active {
            background: #363636;
            color: #fff;

        }
    }
}

.course-description,
.exercise-description {
    span {
        background: transparent !important;
    }
}

.exercise-sidebar {
    padding-bottom: 3rem;

    .countdown {
        padding-left: .5rem;
        //font-weight:700;
    }
}

.vjs-captions-button .vjs-menu {
    font-size: 12px;
    padding: 0 .5rem;
}

.vjs-texttrack-settings {
    display: none !important;
}

.vjs-text-track-display>div>div div {
    font-size: 2.5rem !important;
    transform: translateY(2rem);
    //position:absolute;
    //bottom:1rem;
    //padding:1rem!important;
    background: rgba(0, 0, 0, 0.4) !important;
    display: block !important;
    padding: .5rem !important;

}

.vjs-paused {

    .vjs-loading-spinner,
        {
        display: none !important;
    }

}

.hide-annotations .vjs-overlay {
    display: none !important;
}


.is-active {
    background: transparentize(#42b983, .5);
    color: darken(#fafafa,15%);
    font-weight: 400;

}

.transcript-body {
    min-height: 100px;
    max-height: 320px;
    overflow-x: hidden;
    overflow: auto;
}

.transcript-line {
    cursor: pointer;
    display: inline-block;    
    padding-right:.5rem;
    margin-bottom: 1rem;
}

.vjs-fullscreen .vjs-overlay {
    p {
        font-size: 3rem;
    }

    .control {
        font-size: 2.4rem;

        &::after {
            content: '+';
            position: absolute;
            right: -2.7rem;
            font-size: 2.4rem;
            top: 0;
        }
    }

    .controlkey {
        margin: 1rem 2rem;

    }

    .mousebutton {
        width: 49px;
        height: 69px;

        &.control::after {
            top: 16px;
            right: -2rem;
        }

    }
}

.vjs-button.disabled {
    color: #444;
}

.vjs-overlay {
    box-shadow: 20px 0px 20px -5px rgba(0, 0, 0, 0.5);
    font-size: 2rem;
    font-weight: 400;
    padding: 1rem;
    padding-bottom: 2rem;
    position: absolute;
    bottom: 6rem;
    background: rgba(0, 0, 0, 0.6);

    .buttons {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: space-between;
        align-content: center;
        align-items: center;

        span {
            margin: 0 1rem;
        }
    }

    .fa-ban {
        position: absolute;
        top: 1rem;
        right: 1rem;
        cursor: pointer;
    }

    &.vjs-overlay-bottom-left {
        left: 0;
        animation: lightSpeedLeft .5s ease-in-out;

    }

    &.vjs-overlay-bottom-right {
        right: 0;
        animation: lightSpeedRight .5s ease-in-out;
    }

    p {
        text-align: center;
        padding: 1rem;
    }

    .mousebutton {
        width: 30px;
        height: 42px;
        background-size: 100% 100%;
        background-position: -1px;
        display: inline-block;

        &.lmb {
            background-image: url('../assets/img/lmb.png');
        }

        &.cmb {
            background-image: url('../assets/img/cmb.png');
        }

        &.rmb {
            background-image: url('../assets/img/rmb.png');
        }

        &.control::after {
            top: 8px;
        }
    }

    .controlkey {
        border: 2px solid #aaa;
        padding: .5rem 1rem;
        border-radius: 5px;
        margin: .5rem 1rem;
        text-transform: uppercase;
    }

    .control {
        position: relative;

        &::after {
            content: '+';
            position: absolute;
            right: -2rem;
            font-size: 2rem;
            top: 0;
        }

        &:last-of-type::after {
            display: none;
        }
    }
}

.video-wrapper .ttto-progress {
    height: 6px;
    margin: 0px;
    position: relative;
    top: 0;
}

.video-wrapper {
    //background:#222;
    padding: 0;
}

.description {
    padding: 20px;
}

.video-wrapper .ttto-progress-wrapper {
    height: 6px;
    background-color: #1c1c1c;
}

.reply-button {
    background: #33ccff;
    color: black;
}

.reply-button:hover,
.reply-button:focus {
    background-color: black;
    outline-width: 1px !important;
    outline-offset: 0 !important;
    outline-color: #33ccff !important;
    outline-style: solid !important;
}

.reply-button:focus {
    background-color: #333333;
}

.video-title {
    font-weight:700!important;
}
@keyframes lightSpeedLeft {
    from {
        transform: translate3d(-100%, 0, 0);
        opacity: 0;
    }

    60% {
        opacity: 1;
    }

    80% {
        opacity: 1;
    }

    to {
        transform: none;
        opacity: 1;
    }
}


@keyframes lightSpeedRight {
    from {
        transform: translate3d(100%, 0, 0);
        opacity: 0;
    }

    60% {
        opacity: 1;
    }

    80% {
        opacity: 1;
    }

    to {
        transform: none;
        opacity: 1;
    }
}
.video-description-cms-text {
    ul {
        list-style:disc;
        margin-block-start: 1em;
        margin-block-end: 1em;
        margin-inline-start: 0px;
        margin-inline-end: 0px;
        padding-inline-start: 40px;
    }
}

</style>
to {
transform: none;
opacity: 1;
}
}
</style>



// WEBPACK FOOTER //
// VideoPlayer.vue?137965be